// TourExemplos.jsx
// Mini-previews visuais de cada passo do tour — reproduzem em miniatura o visual real das telas,
// com dados de exemplo. Não são interativos (só ilustração).
import React from 'react';
import {
  FaFileAlt, FaLink, FaCheckSquare, FaSquare, FaSearch, FaCar, FaFileInvoiceDollar,
  FaFileSignature, FaFileContract, FaEdit, FaRegCalendarAlt, FaCheckCircle, FaExchangeAlt
} from 'react-icons/fa';

const TEAL = '#0f766e';
const TEAL_LIGHT = '#f0fdfa';
const TEAL_BORDER = '#99f6e4';

const frame = {
  border: `1px solid ${TEAL_BORDER}`,
  borderRadius: '8px',
  background: TEAL_LIGHT,
  padding: '14px',
  marginTop: '16px',
  pointerEvents: 'none'
};

const badge = (bg, cor) => ({
  fontSize: '10px',
  fontWeight: 700,
  padding: '2px 8px',
  borderRadius: '10px',
  background: bg,
  color: cor
});

const miniInput = {
  border: '1px solid #ddd',
  borderRadius: '5px',
  background: 'white',
  padding: '6px 10px',
  fontSize: '12px',
  color: '#374151',
  display: 'flex',
  alignItems: 'center',
  gap: '6px'
};

const miniLinha = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '6px 0',
  borderBottom: '1px solid #d9f2ee',
  fontSize: '12px',
  color: '#134e4a'
};

const miniBotao = (ativo) => ({
  flex: 1,
  textAlign: 'center',
  padding: '6px',
  borderRadius: '5px',
  fontSize: '11px',
  fontWeight: 700,
  background: ativo ? TEAL : 'white',
  color: ativo ? 'white' : '#6b7280',
  border: `1px solid ${ativo ? TEAL : '#ddd'}`
});

export const ExemploCadastroCliente = () => (
  <div style={frame}>
    <div style={miniInput}><FaSearch size={11} /> Buscar por nome ou CPF/CNPJ...</div>
    <div style={{ ...miniLinha, marginTop: '10px', fontWeight: 700 }}>
      <span>JOÃO DA SILVA</span>
      <span style={{ color: '#6b7280', fontWeight: 400 }}>123.456.789-00</span>
    </div>
  </div>
);

export const ExemploVeiculoDocumento = () => (
  <div style={frame}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <FaCar color={TEAL} />
        <div>
          <div style={{ fontSize: '13px', fontWeight: 700, color: '#134e4a' }}>VW GOL</div>
          <div style={{ fontSize: '11px', color: '#6b7280' }}>ABC-1234</div>
        </div>
      </div>
      <div style={{ ...miniInput, gap: '5px' }}>
        <FaFileAlt size={11} color={TEAL} /> CRLV.pdf
      </div>
    </div>
  </div>
);

export const ExemploImportarCrlv = () => (
  <div style={frame}>
    <div style={{ fontSize: '12px', fontWeight: 700, color: '#134e4a', marginBottom: '6px' }}>Importação (3 de 3)</div>
    <div style={{ height: '6px', borderRadius: '3px', background: TEAL, marginBottom: '6px' }} />
    <div style={miniLinha}>
      <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <FaCheckCircle color="#27ae60" size={12} /> ABC-1D23 — VW GOL
      </span>
      <span style={{ color: '#6b7280' }}>Veículo cadastrado</span>
    </div>
    <div style={miniLinha}>
      <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <FaCheckCircle color="#27ae60" size={12} /> DEF-4G56 — FIAT UNO
      </span>
      <span style={{ color: '#6b7280' }}>Cadastro atualizado</span>
    </div>
    <div style={{ ...miniLinha, borderBottom: 'none' }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <FaExchangeAlt color="#e67e22" size={12} /> GHI-7J89 — HONDA CG
      </span>
      <span style={badge('#fef3cd', '#b7791f')}>Transferir?</span>
    </div>
  </div>
);

export const ExemploServicosHonorarios = () => (
  <div style={frame}>
    <div style={miniLinha}>
      <span>TROCA DE PLACA</span>
      <span style={{ color: '#16a34a', fontWeight: 700 }}>R$ 100,00</span>
    </div>
    <div style={miniLinha}>
      <span>ITR</span>
      <span style={badge('#fef3cd', '#b7791f')}>Aguardando cadastro</span>
    </div>
    <div style={{ ...miniLinha, borderBottom: 'none' }}>
      <span>AUTORIZAÇÃO TRANSPORTE ESCOLAR</span>
      <span style={badge('#ecf0f1', '#7f8c8d')}>Inativo</span>
    </div>
  </div>
);

export const ExemploVincularPassivo = () => (
  <div style={frame}>
    <div style={miniLinha}>
      <span>LICENCIAMENTO</span>
      <FaLink size={12} color="#27ae60" />
    </div>
    <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#134e4a' }}>
        <FaCheckSquare color={TEAL} size={12} /> IPVA
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#6b7280' }}>
        <FaSquare size={12} /> Multas
      </div>
    </div>
  </div>
);

export const ExemploCriarOS = () => (
  <div style={frame}>
    <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '8px' }}>Cliente: JOÃO DA SILVA</div>
    <div style={{ display: 'flex', gap: '8px' }}>
      <div style={miniBotao(true)}>Relacionado a veículo</div>
      <div style={miniBotao(false)}>Não relacionado a veículo</div>
    </div>
  </div>
);

export const ExemploVincularVeiculo = () => (
  <div style={frame}>
    <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
      <div style={miniBotao(true)}>Buscar cadastrado</div>
      <div style={miniBotao(false)}>Informar manualmente</div>
    </div>
    <div style={miniInput}>Placa: AAA-0000</div>
  </div>
);

export const ExemploProcuracao = () => (
  <div style={frame}>
    <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
      <div style={miniBotao(true)}>Em Causa Própria</div>
      <div style={miniBotao(false)}>Aquisição</div>
    </div>
    <div style={miniLinha}>
      <span>Outorgante: JOÃO DA SILVA</span>
      <FaEdit size={11} color={TEAL} />
    </div>
    <div style={{ ...miniLinha, borderBottom: 'none' }}>
      <span>Veículo: ABC-1234</span>
    </div>
  </div>
);

export const ExemploContratos = () => (
  <div style={frame}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
      <span style={{ fontSize: '12px', color: '#134e4a' }}>Vendedor: JOÃO DA SILVA</span>
      <span style={badge('#fef3cd', '#b7791f')}>Alterado</span>
    </div>
    <div style={{ ...miniBotao(true), display: 'inline-block', padding: '6px 12px' }}>
      Salvar no Cadastro
    </div>
  </div>
);

export const ExemploDocumentosComplementares = () => (
  <div style={frame}>
    <div style={miniInput}><FaSearch size={11} /> Buscar documento (ex: "chassi", "baixa")...</div>
    <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
      <span style={badge('white', TEAL)}><FaFileContract style={{ marginRight: '4px' }} />Declaração</span>
      <span style={badge('white', TEAL)}><FaFileSignature style={{ marginRight: '4px' }} />Autorização</span>
    </div>
  </div>
);

export const ExemploAgenda = () => (
  <div style={frame}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
      <FaRegCalendarAlt color={TEAL} />
      <span style={{ fontSize: '12px', fontWeight: 700, color: '#134e4a' }}>22</span>
      <span style={badge(TEAL, 'white')}>3</span>
      <span style={{ fontSize: '11px', color: '#6b7280' }}>lembretes hoje</span>
    </div>
    <div style={{ ...miniBotao(true), display: 'inline-block', padding: '6px 12px' }}>
      + Novo Lembrete
    </div>
  </div>
);

export const ExemploRelatorioCaixa = () => (
  <div style={frame}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        <div style={{ fontSize: '11px', color: '#6b7280' }}>22/09/2026</div>
        <div style={{ fontSize: '13px', fontWeight: 700, color: '#134e4a' }}>12 Ordens de Serviço</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#16a34a', fontWeight: 700 }}>
        <FaFileInvoiceDollar /> R$ 1.240,00
      </div>
    </div>
  </div>
);

export const ExemploConfiguracoes = () => (
  <div style={frame}>
    <div style={{ fontSize: '12px', fontWeight: 700, color: '#134e4a', marginBottom: '8px' }}>Tour do Sistema</div>
    <div style={{ ...miniBotao(true), display: 'inline-block', padding: '8px 14px' }}>
      Ver tour do sistema novamente
    </div>
  </div>
);
